import { useNavigate } from "react-router-dom";
import useAppState from "../../../context/AppContext";
import { APP_RETIREMENT_URLS, ERROR_MESSAGES, PENSION_SERVICE_OPTIONS, PROPOSITION_DOC_TYPES } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import { useForm } from "react-hook-form";
import UploadDocumentTemplate from "../../../components/common-template/UploadDocumentTemplate";
import { IUploadedDoc } from "../../../context/model";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import MgpFormSelect from "../../../elements/MgpFormSelect/MgpFormSelect";

type InfoIdentityBlocFormData = {
  'RETIRED_PENSION_PROOF': IUploadedDoc[];
  pensionServiceCode: string
}

const requiredDocument = PROPOSITION_DOC_TYPES.find(doc=> doc.code === 'RETIRED_PENSION_PROOF')


export default function REInfoRetirementDocBloc() {

  const navigate = useNavigate();
  const {
    state: { familyDoc, updatedProposition, showModal, proposition, additionalData },
    dispatch
  } = useAppState();

   const validationSchema = Yup.object().shape({
      'RETIRED_PENSION_PROOF': Yup.array().min(1).required(ERROR_MESSAGES.requiredMsg),
      pensionServiceCode: Yup.string().required(ERROR_MESSAGES.requiredMsg)
    });

    const {
    setValue,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<InfoIdentityBlocFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      'RETIRED_PENSION_PROOF': familyDoc.filter(
        (doc:any)=> doc.fileType === requiredDocument?.code),
      pensionServiceCode: updatedProposition?.pensionServiceCode ?? ""
    },
    resolver: yupResolver(validationSchema), 
  });

  const onPreviousAction = async () => {
    const hasBeneficiaryStep = additionalData?.hasChild || additionalData?.hasPartner;
    
    const url = proposition?.configuration?.requireIdentityDocument 
                  ? APP_RETIREMENT_URLS.infoIdentityDocPage 
                  : hasBeneficiaryStep 
                      ? APP_RETIREMENT_URLS.infoBeneficiaryPage 
                      : APP_RETIREMENT_URLS.infoAttestationROPage;
    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
        pathname: url
    });         
  }

 const onNextAction = async (data: InfoIdentityBlocFormData) => {
    let tempUpdatedPropo = updatedProposition;
    if(tempUpdatedPropo) {
      tempUpdatedPropo.pensionServiceCode = data.pensionServiceCode;
    }
     
    const nextUrl = APP_RETIREMENT_URLS.infoLastEmployeeDocPage;
    dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
    navigate({
        pathname: nextUrl
    });     
}

 
  return (
    <form style={{width: '100%'}}> 
        <div className="form-row">
          <p className="bleu fw-medium mb-sm">Service gestionnaire de pension <span className="fushia">(*)</span></p>
        </div>
      
        <div className="form-row">
  
          <div className="form-group mw-45">
            <MgpFormSelect 
              id="pensionServiceCode"
              labelFontWeight='regular'
              data={PENSION_SERVICE_OPTIONS}
              register={register}
              errors={errors}
              label=''
              required={true}
            />
          </div>
        </div>

        <div className="form-row mt-lg">
          <p className="text mt-sm bleu fw-medium mw-100"> 
            Veuillez télécharger les document suivants (.pdf, .jpg, .jpeg ou .png)
          </p>
        </div>

        <div>
          <UploadDocumentTemplate
            requiredDocuments={requiredDocument!}
            errors= {errors}
            isUploadMultipe= {true}
            setValue={setValue}
          />
        </div> 
     
       
        <div className="mt-xl">
          <p className='text fw-medium'>
            <span className='fushia'>(*)</span> Champs obligatoires
          </p>
        </div>
      
      {!showModal &&
      <StickButtonsBloc 
        showPreviousButton={true} 
        disabledPreviousButton={false} 
        nextAction={handleSubmit(onNextAction)} 
        showNextButton={true} 
        previousAction={onPreviousAction}/> }
    </form>
  )
}